module.exports = __webpack_public_path__ + "static/media/read_content_aloud_punjabi.e5d76860.mp3";